export default __webpack_public_path__ + "static/media/lander1.dfcb5633.jpeg";